import React, { useEffect, useState } from "react";
import Card from "components/card";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { fetchData } from "../../../../services/ApiFetching";
import CustomDropdown from "components/dropdown/CustomDropdown";

const columnHelper = createColumnHelper();

function UserTableDashboard() {
  const [selectedView, setSelectedView] = useState("today");
  const [sorting, setSorting] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
  const fetchStats = async () => {
    try {
      const stats = await fetchData(`dashboard/getUserTicketCount?view=${selectedView}`);
      const transformed = stats.map((user) => ({
        id: user.id,
        name: user.username,
        total: user.total_tickets,
        escalated: user.escalated_tickets,
        open: user.open_tickets,
        resolved: user.resolved_tickets,
      }));
      setData(transformed);
    } catch (error) {
      console.error("Error fetching ticket stats:", error.message);
    }
  };

  fetchStats();
}, [selectedView]);

  const columns = [
    columnHelper.accessor("name", {
      id: "name",
      header: () => <p className="text-sm font-bold text-gray-600 dark:text-white">USERNAME</p>,
      cell: (info) => <p className="text-sm font-bold text-navy-700 dark:text-white">{info.getValue()}</p>,
    }),
    columnHelper.accessor("open", {
      id: "open",
      header: () => <p className="text-sm font-bold text-gray-600 dark:text-white">OPEN</p>,
      cell: (info) => <p className="text-sm text-gray-700 dark:text-white">{info.getValue()}</p>,
    }),
    columnHelper.accessor("resolved", {
      id: "resolved",
      header: () => <p className="text-sm font-bold text-gray-600 dark:text-white">RESOLVED</p>,
      cell: (info) => <p className="text-sm text-gray-700 dark:text-white">{info.getValue()}</p>,
    }),
    columnHelper.accessor("escalated", {
      id: "escalated",
      header: () => <p className="text-sm font-bold text-gray-600 dark:text-white">ESCALATED</p>,
      cell: (info) => <p className="text-sm text-red-500 dark:text-red-400">{info.getValue()}</p>,
    }),
    columnHelper.accessor("total", {
      id: "total",
      header: () => <p className="text-sm font-bold text-gray-600 dark:text-white">TOTAL</p>,
      cell: (info) => <p className="text-sm text-gray-700 dark:text-white">{info.getValue()}</p>,
    }),
  ];

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  return (
    <Card extra={"w-full h-full sm:overflow-auto px-6"}>
      <header className="relative flex items-center justify-between pt-4">
        <div className="text-xl font-bold text-navy-700 dark:text-white">USER TICKET STATUS</div>
        <CustomDropdown
          label="View"
          options={[
            { label: "Today", value: "today" },
            { label: "Total", value: "total" },
          ]}
          value={selectedView}
          onChange={(value) => setSelectedView(value)} // ✅ just use value
        />


      </header>

      <div className="mt-2 overflow-x-scroll xl:overflow-x-hidden">
        <div className="max-h-[75vh] overflow-y-auto">
          <table className="w-full">
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id} className="!border-px !border-gray-400">
                  {headerGroup.headers.map((header) => (
                    <th
                      key={header.id}
                      colSpan={header.colSpan}
                      onClick={header.column.getToggleSortingHandler()}
                      className="cursor-pointer border-b-[1px] border-gray-200 pt-4 pb-2 pr-4 text-start"
                    >
                      <div className="items-center justify-between text-xs text-gray-200">
                        {flexRender(header.column.columnDef.header, header.getContext())}
                        {{
                          asc: "",
                          desc: "",
                        }[header.column.getIsSorted()] ?? null}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map((row) => (
                <tr key={row.id}>
                  {row.getVisibleCells().map((cell) => (
                    <td
                      key={cell.id}
                      className="min-w-[150px] border-white/0 py-3 pr-4"
                    >
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Card>
  );
}

export default UserTableDashboard;
